import { HeroFeatureStrip } from './HeroFeatureStrip.jsx';

function heroFlyItemClass(step, visibleStep) {
  return `pp-landing-hero__fly-item${visibleStep >= step ? ' is-visible' : ''}`;
}

function ListingIcon() {
  return (
    <svg viewBox="0 0 24 24" fill="none" aria-hidden="true" focusable="false">
      <path d="M4 10.5L12 4L20 10.5V19C20 20.1 19.1 21 18 21H6C4.9 21 4 20.1 4 19V10.5Z" stroke="currentColor" strokeWidth="1.8" strokeLinejoin="round" />
      <path d="M9 21V14H15V21" stroke="currentColor" strokeWidth="1.8" strokeLinejoin="round" />
      <rect x="14" y="8" width="5" height="6" rx="1" stroke="currentColor" strokeWidth="1.6" />
    </svg>
  );
}

function ProsorguIcon() {
  return (
    <svg viewBox="0 0 24 24" fill="none" aria-hidden="true" focusable="false">
      <rect x="3" y="4" width="18" height="14" rx="2" stroke="currentColor" strokeWidth="1.8" />
      <path d="M7 16H13M7 12H17M7 8H11" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
      <circle cx="17" cy="16" r="3" stroke="currentColor" strokeWidth="1.8" />
      <path d="M19 18L21 20" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
    </svg>
  );
}

function HeroProductCard({ variant, label, title, features, cta, href, visibleStep, flyStep }) {
  const cardClass = [
    'pp-landing-hero-v2__card',
    variant === 'listing' ? 'pp-landing-hero-v2__card--listing' : 'pp-landing-hero-v2__card--prosorgu',
    heroFlyItemClass(flyStep, visibleStep),
  ].join(' ');

  return (
    <a class={cardClass} href={href}>
      <span class="pp-landing-hero-v2__card-icon" aria-hidden="true">
        {variant === 'listing' ? <ListingIcon /> : <ProsorguIcon />}
      </span>
      <p class="pp-landing-hero-v2__card-label">{label}</p>
      <h2 class="pp-landing-hero-v2__card-title">{title}</h2>
      <ul class="pp-landing-hero-v2__card-features">
        {features.map((feature) => (
          <li key={feature}>{feature}</li>
        ))}
      </ul>
      <span class="pp-landing-hero-v2__card-cta">
        {cta}
        <span aria-hidden="true">→</span>
      </span>
    </a>
  );
}

function HeroGiftBanner({ giftAmount, registerUrl, visibleStep, flyStep }) {
  if (!giftAmount || giftAmount <= 0) return null;

  return (
    <div class={`pp-landing-hero-v2__gift ${heroFlyItemClass(flyStep, visibleStep)}`}>
      <div class="pp-landing-hero-v2__gift-copy">
        <span class="pp-landing-hero-v2__gift-icon" aria-hidden="true">🎁</span>
        <div>
          <p class="pp-landing-hero-v2__gift-title">
            Yeni Üyelere <strong>{giftAmount} Kredi Hediye</strong>
          </p>
          <p class="pp-landing-hero-v2__gift-sub">
            Ücretsiz üye olun, kredilerinizi hemen kullanmaya başlayın.
          </p>
        </div>
      </div>
      <a class="pp-landing-hero-v2__gift-cta" href={registerUrl}>
        Ücretsiz Üye Ol
        <span aria-hidden="true">→</span>
      </a>
    </div>
  );
}

function HeroPersonPanel({ photoUrl, visibleStep, flyStep }) {
  if (!photoUrl) return null;

  return (
    <aside class={`pp-landing-hero-v2__person ${heroFlyItemClass(flyStep, visibleStep)}`}>
      <div class="pp-landing-hero-v2__person-photo-wrap">
        <img
          class="pp-landing-hero-v2__person-photo"
          src={photoUrl}
          alt="Taha Başparmak — Genel Müdür"
          loading="lazy"
          decoding="async"
        />
      </div>
      <div class="pp-landing-hero-v2__person-meta">
        <span class="pp-landing-hero-v2__person-accent" aria-hidden="true" />
        <div>
          <strong>Taha Başparmak</strong>
          <span>Genel Müdür</span>
        </div>
      </div>
    </aside>
  );
}

/**
 * Premium 3 kolonlu landing hero — dashboard + satış kartları + Taha Başparmak.
 */
export function HeroConversionSection({
  assets,
  visibleStep,
  registrationCredits = 0,
  ilanCreateUrl,
  prosorguUrl,
  registerUrl,
}) {
  const giftAmount = Number(registrationCredits) || 0;

  return (
    <>
      <div class="pp-landing-hero-v2__grid">
        <div class="pp-landing-hero-v2__center">
          <h1 id="landing-hero-title" class={`pp-landing-hero-v2__headline ${heroFlyItemClass(1, visibleStep)}`}>
            <span>Parselinizi Analiz Edin,</span>
            <span class="pp-landing-hero-v2__headline-accent">İlanınızı Hemen Yayınlayın</span>
          </h1>

          <p class={`pp-landing-hero-v2__lead ${heroFlyItemClass(2, visibleStep)}`}>
            ProParcel ve Gülümseten Emlak ile alım satım ve analiz süreçlerinizi tek ekrandan yönetin.
          </p>

          <div class="pp-landing-hero-v2__cards" role="list">
            <HeroProductCard
              variant="listing"
              label="EMLAK İLANI"
              title="İlanınızı Yayınlayın"
              features={['EİDS Yetkili İlan', 'Hızlı Yayın', 'Portföy Görünürlüğü']}
              cta="İlanını Yayınla"
              href={ilanCreateUrl}
              visibleStep={visibleStep}
              flyStep={3}
            />
            <HeroProductCard
              variant="prosorgu"
              label="PROSORGU"
              title="Parselinizi Analiz Edin"
              features={['Fiyat Analizi', 'Ada / Parsel Sorgu', 'İmar Verisi']}
              cta="Analize Başla"
              href={prosorguUrl}
              visibleStep={visibleStep}
              flyStep={3}
            />
          </div>

          <HeroGiftBanner
            giftAmount={giftAmount}
            registerUrl={registerUrl}
            visibleStep={visibleStep}
            flyStep={4}
          />
        </div>

        <HeroPersonPanel
          photoUrl={assets.tahaPhoto}
          visibleStep={visibleStep}
          flyStep={3}
        />
      </div>

      <HeroFeatureStrip />
    </>
  );
}
